/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpageemptybody3Inputs */

const en_ticketpageemptybody3 = /** @type {(inputs: Ticketpageemptybody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As soon as someone gets a ticket, the order shows up here.`)
};

const de_ticketpageemptybody3 = /** @type {(inputs: Ticketpageemptybody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobald jemand ein Ticket holt, steht die Bestellung hier.`)
};

/**
* | output |
* | --- |
* | "As soon as someone gets a ticket, the order shows up here." |
*
* @param {Ticketpageemptybody3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpageemptybody3 = /** @type {((inputs?: Ticketpageemptybody3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpageemptybody3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpageemptybody3(inputs)
	return de_ticketpageemptybody3(inputs)
});
export { ticketpageemptybody3 as "ticketPageEmptyBody" }